export default __webpack_public_path__ + "static/media/donescreen-1.0f18f9e6.jpg";